import { Component, inject, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MatchService } from '../../../shared/services/match.service';
import { empty } from '../../../functions';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-modal-admin-matchtest-competency',
  templateUrl: './modal-admin-matchtest-competency.component.html',
  styleUrls: ['./modal-admin-matchtest-competency.component.scss'],
  standalone: true,
  imports: [TranslateModule, FormsModule, CommonModule],
})
export class ModalAdminMatchtestCompetencyComponent implements OnInit {
  matchService = inject(MatchService);

  public data: any;

  public entity = {
    id: '',
    name: '',
    type: '',
    description: '',
  };

  competencyTypes: {
    value: string;
    name: string;
  }[] = [];

  /**
   * Constructor
   *
   * @param activeModel
   */
  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    this.entity = Object.assign({}, this.data.entity);
    this.competencyTypes = this.matchService.getMatchtestCompetencyTypes();
  }

  /**
   * Save
   *
   * @constructor
   */
  Save() {
    if (!empty(this.entity.id)) {
      // Update company profile
      this.matchService
        .apiUpdateMatchtestCompetency(this.entity.id, this.entity)
        .subscribe((result) => {
          this.activeModal.close(true);
        });
    } else {
      const { id, ...body } = this.entity;
      this.matchService
        .apiAddMatchtestCompetency(body)
        .subscribe((result) => {
          this.activeModal.close(true);
        });
    }
  }
}
